<template>
  <b-modal
    id="modal-not-registered-komship"
    ref="modal-not-registered-komship"
    hide-header
    hide-footer
    centered
    dialog-class="modal-dialog-centered !max-w-[480px] !w-full mx-auto"
    content-class="!rounded-[16px] !border-0 shadow-lg overflow-hidden bg-white"
    body-class="!p-0"
  >
    <div class="p-6 bg-white">
      <!-- Header: Title & Close Button -->
      <div class="flex items-start justify-between">
        <h4 class="text-[18px] font-semibold text-[#22292F] m-0 leading-normal">
          Belum Terdaftar Komship
        </h4>
        <button
          type="button"
          class="text-[#828282] hover:text-[#22292F] transition-colors cursor-pointer bg-transparent border-0 p-0 ml-3 inline-flex items-center justify-center focus:outline-none"
          @click="closeModal"
        >
          <feather-icon
            icon="XIcon"
            size="20"
          />
        </button>
      </div>

      <!-- Description / Body -->
      <p class="text-[#828282] text-[14px] leading-relaxed mt-2.5 mb-0 text-left">
        Belum terdaftar dengan <strong class="font-bold text-[#22292F]">Komship</strong>. Daftar untuk dapat menggunakan fitur <strong class="font-bold text-[#22292F]">Ajukan Pickup</strong>.
      </p>

      <!-- Action Buttons -->
      <div class="flex items-center justify-end gap-3 mt-6">
        <button
          type="button"
          class="inline-flex items-center justify-center rounded-[10px] text-sm font-medium border border-[#D8D6DE] bg-white hover:bg-gray-50 text-[#22292F] h-[40px] px-6 cursor-pointer shadow-sm transition-colors focus:outline-none"
          @click="closeModal"
        >
          Batal
        </button>
        <button
          type="button"
          class="inline-flex items-center justify-center rounded-[10px] text-sm font-medium bg-[#F95031] hover:bg-[#E03F21] text-white border-0 h-[40px] px-6 cursor-pointer transition-colors focus:outline-none"
          @click="onRegister"
        >
          Daftar Sekarang
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'ModalNotRegisteredKomship',
  methods: {
    closeModal() {
      this.$bvModal.hide('modal-not-registered-komship')
    },
    onRegister() {
      window.open('https://komship.id/pendaftaran', '_blank')
      this.closeModal()
    },
  },
}
</script>
